/** PURE_IMPORTS_START ._IntervalObservable PURE_IMPORTS_END */
import { IntervalObservable } from './IntervalObservable';
export var interval = IntervalObservable.create;
//# sourceMappingURL=interval.js.map



//////////////////
// WEBPACK FOOTER
// ./node_modules/rxjs/_esm5/observable/interval.js
// module id = ./node_modules/rxjs/_esm5/observable/interval.js
// module chunks = vendor